import { TechnologyDictionaryModel } from "../../models/technology.model";
import { BackendHttpService } from "../backendHttpService";

/**
 * Technology Dictionary Service
 *
 * Pure read-only service for accessing technology dictionary data.
 * This service is focused solely on retrieving dictionary information
 * and is designed to be used by both regular services and React Query hooks.
 *
 * For admin operations (create, update, delete), use TechnologyDictionaryAdminService.
 */
export class TechnologyDictionaryService extends BackendHttpService {
  // Cache for technology dictionary
  private technologiesDictionaryCache: TechnologyDictionaryModel[] | null =
    null;

  constructor() {
    super("technology");
  }

  /**
   * Get all technologies from dictionary with categories
   * GET /technology/dictionary?includeCategories=true
   */
  async getTechnologiesDictionary(): Promise<TechnologyDictionaryModel[]> {
    if (this.technologiesDictionaryCache) {
      return this.technologiesDictionaryCache;
    }

    try {
      this.technologiesDictionaryCache = await this.get<
        TechnologyDictionaryModel[]
      >("/dictionary?includeCategories=true");
      return this.technologiesDictionaryCache;
    } catch (error) {
      console.error("Error getting technologies dictionary:", error);
      throw error;
    }
  }

  /**
   * Clear the cached dictionary data
   * Used when dictionary is modified through admin operations
   */
  clearCache(): void {
    this.technologiesDictionaryCache = null;
  }
}

// Create and export a singleton instance for consistency
export const technologyDictionaryService = new TechnologyDictionaryService();
